module.exports=function(scope){ return `var https = require("https");

callFaceTecAPI("/status", function(error, result) {
  if(error) {
    console.log("Error:" + error);
  }
  else if(result) {
    console.log(result)
  }
})

function callFaceTecAPI(path, callback){
  var options = {
    hostname: "your.internal.zoomserver.instance.url",
    port: 443,
    path: path,
    method: "GET",
    headers: {
        "Content-Type": "application/json"
    }
  }

  var req = https.request(options, (res) => {
      var output = ""

      res.on("data", (d) => {
          output += d
      })

      res.on("end", () => {
        try{
          var obj = JSON.parse(output)
          callback(undefined, obj)
        }
        catch(error) {
          callback(error, undefined)
        }
      })
  })

  req.on("error", (error) => {
    callback(error, undefined)
  })

  req.end()
}
`};


// WEBPACK FOOTER //
// ./src/resources/code/restsdk-v2/nodejs/test-connection.js.tpl